<div class="min-h-[60vh] flex items-center justify-center">
  <div class="bg-white shadow-lg rounded-lg p-8 max-w-lg text-center" data-testid="qr-visit-wip">
    <i class="fas fa-screwdriver-wrench text-3xl text-gray-400"></i>
    <h1 class="text-xl font-semibold text-gray-700 mt-3">En cours de développement</h1>
    <p class="text-gray-500 mt-2">
      La vue QR-Code des visites sera bientôt disponible.
    </p>
    <p class="text-xs text-gray-400 mt-4">
      client {{ clientId }} / POS {{ posId }}
    </p>
    <button type="button" (click)="closeTab()" data-testid="qr-visit-wip-close"
      class="inline-block mt-6 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded transition-colors">
      Fermer cet onglet
    </button>
  </div>
</div>
